import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import clsx from "clsx";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { AnimatePresence, motion } from "framer-motion";
import { useRef } from "react";

interface BaseMenuItemProps {
  title: string;
  url?: string;
  subMenuContent?: React.ReactNode;
  onPrefetch?: () => void;
}

export default function BaseMenuItem({
  title,
  url,
  subMenuContent,
  onPrefetch,
}: BaseMenuItemProps) {
  const prefetched = useRef(false);
  const prefetch = () => {
    if (prefetched.current || !onPrefetch) return;
    prefetched.current = true;
    onPrefetch();
  };

  return (
    <Popover
      className="xgroup xflex-1 xh-full
      xflex xitems-center xjustify-center
      xwhitespace-nowrap
      xw-28"
    >
      {({ open }) => (
        <>
          <PopoverButton
            className="
              xh-full
              xflex xitems-center xjustify-center xgap-2
              xtext-extra-dark-green
              xfont-grotesque
              xtext-4xl
              xfont-bold
            "
            onPointerEnter={prefetch}
            onFocus={prefetch}
            {...(url && {
              onClick: (e) => {
                e.preventDefault();
                window.location.href = url;
              },
            })}
          >
            {title}
            {subMenuContent && (
              <ChevronDownIcon
                className={clsx("xsize-8 xmt-1", open && "xrotate-180")}
              />
            )}
          </PopoverButton>
          <AnimatePresence>
            {open && subMenuContent && (
              <PopoverPanel
                anchor="bottom"
                static
                as={motion.div}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                modal={true}
                focus={true}
                className="
                      xz-50
                      xw-screen xh-[350px]
                      xbg-green-creme
                      xpy-12 xpx-24
                      xflex xjustify-center
                      xshadow-lg
                    "
              >
                <div className="xw-page-width xpx-8 xflex xgap-12 xjustify-between">
                  {subMenuContent}
                </div>
              </PopoverPanel>
            )}
          </AnimatePresence>
        </>
      )}
    </Popover>
  );
}
